import { Stack, TextField, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import './ProfileBox.scss';
import { filterUndefined } from '../../utils/FilterUndefinedObject';

const defaultProps = {
  className: '',
  name: '',
  label: '',
  value: '',
  onChange: () => {},
  isEdit: false,
  helperText: '',
  type: '',
  endDecorator: null,
  fullWidth: false,
  isRequired: false,
  onFocus: () => null,
  onBlur: () => null,
  disabled: false,
};

const ProfileBox = (props) => {
  const {
    label,
    name,
    value,
    onChange,
    type,
    className,
    isEdit,
    helperText,
    endDecorator,
    fullWidth,
    isRequired,
    onFocus,
    onBlur,
    disabled,
  } = { ...defaultProps, ...filterUndefined(props) };

  return (
    <Box data-test={`${name}-profile-box`} className={`profile-box ${className}`}>
      <Stack direction='row' gap={2} alignItems='center' position='relative'>
        <Typography className={`profile-box-label ${isRequired ? 'required' : ''}`}>
          {label}
        </Typography>
        <Box className='end-decorator-container'>
          {endDecorator}
        </Box>
      </Stack>
      <TextField
        data-test={`${name}-profile-text-field`}
        className='profile-box-textfield'
        name={name}
        value={value}
        onChange={onChange}
        type={type}
        helperText={helperText}
        variant='outlined'
        data-private
        inputProps={{
          'aria-label': label || name || 'profile-box-input',
          readOnly: !isEdit || disabled,
          autoComplete: type === 'password' ? 'new-password' : null,
          'data-private': 'redact',
          'data-dd-privacy': ['firstName', 'lastName', 'userName', 'emailAddress', 'stateIdentifier'].includes(name) ? 'mask' : undefined,
        }}
        fullWidth={fullWidth}
        required={isRequired}
        onFocus={onFocus}
        onBlur={onBlur}
      />
    </Box>
  );
};

export default ProfileBox;
